module.exports = __webpack_public_path__ + "static/media/live-icon.25ee6a61.svg";